export default __webpack_public_path__ + "df47743a45477525f74839e10cd44ec0.woff2";